import { IconProps } from '.';

export const EyeIcon = ({ className, color = 'black' }: IconProps) => {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.05026 6.36396C6.78393 3.63029 11.2161 3.63029 13.9497 6.36396L16.5858 9L13.9497 11.636C11.2161 14.3697 6.78392 14.3697 4.05025 11.636L1.41421 9L4.05026 6.36396Z'
        stroke={color}
        strokeWidth='2'
      ></path>
      <circle cx='9' cy='9' r='2' stroke={color} strokeWidth='2'></circle>
    </svg>
  );
};

export const EyeIcon2 = ({ className, color = 'currentColor' }: IconProps) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M9.19531 6.75977C9.07111 6.9782 9 7.23076 9 7.5C9 8.32843 9.67157 9 10.5 9C10.7691 9 11.0209 8.9278 11.2393 8.80371C11.2449 8.86846 11.25 8.9338 11.25 9C11.25 10.2426 10.2426 11.25 9 11.25C7.75736 11.25 6.75 10.2426 6.75 9C6.75 7.75736 7.75736 6.75 9 6.75C9.06584 6.75 9.13091 6.75422 9.19531 6.75977Z'
        fill={color}
      />
      <path
        d='M5.33691 5.33594C7.64507 4.19215 10.3549 4.19215 12.6631 5.33594C13.7607 5.87984 14.8047 6.87399 16.9355 9C14.8047 11.126 13.7607 12.1202 12.6631 12.6641C10.3549 13.8079 7.64507 13.8079 5.33691 12.6641C4.23926 12.1201 3.19463 11.1263 1.06348 9C3.19463 6.87365 4.23925 5.87988 5.33691 5.33594Z'
        stroke={color}
        strokeWidth='1.5'
      />
    </svg>
  );
};
